export const switchTokens = {
  toggleswitch: {
    root: {
      width: '2.75rem',
      height: '1.5rem',
      borderRadius: '{borderRadius.xxl}',
      gap: '0.125rem',
      shadow: 'none',
      hoverBorderColor: 'transparent',
      checkedBorderColor: 'transparent',
      checkedHoverBorderColor: 'transparent',
      invalidBorderColor: '{formField.invalidBorderColor}',
      transitionDuration: '{transition.duration}',
      slideDuration: '{transition.duration}',
      focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
      }
    },
    handle: {
      size: '1.25rem',
      borderRadius: '{borderRadius.xxl}'
    },
    colorScheme: {
      light: {
        root: {
          background: '{surface.300}',
          hoverBackground: '{surface.300}',
          checkedBackground: '{primary.color}',
          checkedHoverBackground: '{primary.color}',
          disabledBackground: '{surface.200}'
        },
        handle: {
          background: '{surface.0}',
          hoverBackground: '{surface.0}',
          checkedBackground: '{surface.0}',
          checkedHoverBackground: '{surface.0}',
          disabledBackground: '{surface.200}',
          color: '{surface.400}',
          hoverColor: '{primary.color}',
          checkedColor: '{primary.color}',
          checkedHoverColor: '{primary.color}'
        }
      }
    }
  }
};

export type SwitchTokens = typeof switchTokens;
